export default __webpack_public_path__ + "static/media/Axe_1.5397f620.png";